import React from 'react';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import './countdown-style.css';
import { useTranslation } from 'react-i18next';

export const CountDown = ({ blok }) => {
  const { t } = useTranslation(['countdown']);
  const targetDate = blok.target_time
    ? new Date(blok.target_time)
    : new Date().getTime() + 24 * 3600 * 1000 + 5000;

  return (
    <FlipClockCountdown
      className={`flip-clock px-4 pt-0 md:pt-5 pb-2 ${blok.margin_top}`}
      to={targetDate}
      labels={[t('DAYS'), t('HOURS'), t('MINUTES'), t('SECONDS')]}
      digitBlockStyle={{
        width: 20,
        height: 30,
        fontSize: 12,
        fontFamily: 'Crystal-Condensed',
      }}
      dividerStyle={{ color: '#808080', height: 0 }}
      separatorStyle={{ color: '#222222', size: '2px' }}
      labelStyle={{
        fontSize: 8,
        fontFamily: 'Crystal-Light',
      }}
      renderOnServer={true}
    />
  );
};

export default CountDown;
